import { call, put, getContext, takeEvery, select } from 'redux-saga/effects';
import { SubmissionError, FormAction as BaseFormAction } from 'redux-form';
import { ApolloError } from 'apollo-client';
import { Tokens } from '@unitedtraders/keycloak';
import { actions as appActions } from '../../../../actions/app';
import { SagaContext } from '../../../../types/common';
import * as gtmDataLayer from '../../../../utils/gtmDataLayer';
import { routine } from './actions';
import { FormData } from './constraints';
import { Services } from 'init/services';
import { selector } from '../../selector';
import { getFormErrors } from 'shared/utils/formatError';
import { lifecycle } from '../../actions';

interface FormAction extends BaseFormAction {
  payload: {
    values: FormData;
  };
}

// @translate
type Errors =
  | 'invalid_grant'
  | 'TooManyWrongSecondFactorAttemptsException'
  | 'UserOTPValidationException'
  | 'Invalid2FACodeException';

function* saga() {
  const keycloakService: Services['keycloakService'] = yield getContext(
    SagaContext.KeycloakService
  );

  yield takeEvery(
    routine.TRIGGER,
    function* ({
      payload: {
        values: { code },
      },
    }: FormAction) {
      const { secondFactor }: ReturnType<typeof selector> = yield select(selector);
      if (!secondFactor) {
        routine.failure(new SubmissionError({ _error: 'Unknown error' }));
        return;
      }

      try {
        const response: Tokens = yield call(() =>
          keycloakService.authorizeBySecondFactor(secondFactor.sessionId, code.replace(/\s+/g, ''))
        );

        gtmDataLayer.push({
          eventCategory: 'form',
          eventAction: 'login',
          eventLabel: 'login-success',
        });

        yield put(appActions.login());
        yield put(routine.success(response));
        yield put(lifecycle.deactivate());
      } catch (e: ApolloError | any) {
        // details.message is not translate friendly, so use exception name in type field
        // type can be 'com.unitedtraders.luna.sessionservice.exceptions.Invalid2FACodeException'
        const error = getFormErrors(e);

        yield put(routine.failure(new SubmissionError<FormData, Errors>(error)));
      }
      return;
    }
  );
}

export default saga;
